"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _heroBrand = require("@mmc/hero-brand");
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSlick = _interopRequireDefault(require("react-slick"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _arrow = _interopRequireDefault(require("../assets/icons/arrow.svg"));
var _heroCarousel = _interopRequireDefault(require("../styles/hero-carousel.css"));
var _heroCarousel2 = _interopRequireDefault(require("./hero-carousel.props/hero-carousel.defaultProps"));
var _heroCarousel3 = _interopRequireDefault(require("./hero-carousel.props/hero-carousel.propTypes"));
var _img, _img2;
var _excluded = ["slides", "className", "autoplay", "autoplaySpeed", "cyclical"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps;
var HeroCarousel = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(HeroCarousel, _React$Component);
  HeroCarousel.resourceType = function resourceType() {
    return 'Hero_Carousel_1_0_0';
  };
  function HeroCarousel(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.sliderRef = /*#__PURE__*/_react["default"].createRef();
    _this.showPrevSlide = _this.showPrevSlide.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showNextSlide = _this.showNextSlide.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getRef = _this.getRef.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      showLeftArrow: false,
      showRightArrow: false,
      slides: [],
      className: '',
      autoplay: false,
      autoplaySpeed: 0,
      cyclical: false
    };
    return _this;
  }
  var _proto = HeroCarousel.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
      data = _this$props.data,
      defaultData = _this$props.defaultData,
      _this$state = this.state,
      slides = _this$state.slides,
      className = _this$state.className,
      autoplay = _this$state.autoplay,
      autoplaySpeed = _this$state.autoplaySpeed,
      cyclical = _this$state.cyclical,
      prevState = (0, _objectWithoutPropertiesLoose2["default"])(_this$state, _excluded);
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    this.setState(_objectSpread({
      slides: componentData.slides,
      className: componentData.className,
      autoplay: componentData.autoplay,
      autoplaySpeed: componentData.autoplaySpeed,
      cyclical: componentData.cyclical
    }, prevState));
    this.handleChange(0, slides.length, cyclical);
  };
  _proto.handleChange = function handleChange(currentSlide, slidesLength, cyclical) {
    var slidesLengthFormatted = slidesLength - 1;
    var isLastSlide = currentSlide === slidesLengthFormatted;
    var isFirstSlide = currentSlide === 0;
    if (cyclical) return null;
    if (isLastSlide && !isFirstSlide) {
      this.setState({
        showLeftArrow: true,
        showRightArrow: false
      });
    } else if (isFirstSlide) {
      this.setState({
        showLeftArrow: false,
        showRightArrow: true
      });
    }
    if (!isLastSlide && !isFirstSlide) {
      this.setState({
        showLeftArrow: true,
        showRightArrow: true
      });
    }
  };
  _proto.getRef = function getRef(c) {
    this.sliderRef.current = c;
  };
  _proto.showPrevSlide = function showPrevSlide() {
    this.sliderRef.current.slickPrev();
  };
  _proto.showNextSlide = function showNextSlide() {
    this.sliderRef.current.slickNext();
  };
  _proto.render = function render() {
    var theme = this.props.theme,
      _this$state2 = this.state,
      slides = _this$state2.slides,
      className = _this$state2.className,
      autoplay = _this$state2.autoplay,
      autoplaySpeed = _this$state2.autoplaySpeed,
      cyclical = _this$state2.cyclical,
      showLeftArrow = _this$state2.showLeftArrow,
      showRightArrow = _this$state2.showRightArrow,
      showPrevSlide = this.showPrevSlide,
      showNextSlide = this.showNextSlide,
      getRef = this.getRef,
      handleChange = this.handleChange;
    var hasOneSlide = slides.length === 1;
    var renderLeftArrow = cyclical || showLeftArrow && !hasOneSlide;
    var renderRightArrow = cyclical || showRightArrow && !hasOneSlide;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + _heroCarousel["default"].wrapper
    }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], {
      ref: getRef,
      className: (0, _clsx["default"])(_heroCarousel["default"].slider, className),
      dots: true,
      infinite: cyclical,
      speed: 500,
      slidesToShow: 1,
      autoplay: autoplay,
      autoplaySpeed: autoplaySpeed,
      afterChange: function afterChange(currentSlide) {
        return handleChange(currentSlide, slides.length, cyclical);
      }
    }, slides.map(function (slide) {
      return /*#__PURE__*/_react["default"].createElement(_heroBrand.HeroBrand, {
        key: slide.id,
        theme: theme,
        data: slide
      });
    })), renderLeftArrow && /*#__PURE__*/_react["default"].createElement("button", {
      className: _heroCarousel["default"].arrow + " " + _heroCarousel["default"].arrowLeft,
      onClick: showPrevSlide,
      type: "button"
    }, _img || (_img = /*#__PURE__*/_react["default"].createElement("img", {
      src: _arrow["default"],
      alt: "left arrow"
    }))), renderRightArrow && /*#__PURE__*/_react["default"].createElement("button", {
      className: _heroCarousel["default"].arrow + " " + _heroCarousel["default"].arrowRight,
      onClick: showNextSlide,
      type: "button"
    }, _img2 || (_img2 = /*#__PURE__*/_react["default"].createElement("img", {
      src: _arrow["default"],
      alt: "right arrow"
    }))));
  };
  return HeroCarousel;
}(_react["default"].Component);
exports["default"] = HeroCarousel;
HeroCarousel.displayName = 'HeroCarousel';
HeroCarousel.defaultProps = {
  data: _heroCarousel2["default"],
  defaultData: _heroCarousel2["default"]
};